<template>
  <div class="d-flex align-center mb-1">
    <v-icon
      :color="passes ? 'green' : 'red'"
      :icon="passes ? 'check_circle' : 'cancel'"
      size="22"
    />

    <span class="ml-2 fw-300 fs-16">
      {{ $bct(message) }}
    </span>
  </div>
</template>

<script setup>
const $bct = inject('translator');

defineProps({
  message: {
    type: String,
    required: true,
  },
  passes: {
    type: Boolean,
    required: true,
  },
});
</script>
